var _style, _g, _g2, _g3, _polygon, _polygon2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogook01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.7 141.7",
    style: {
      enableBackground: "new 0 0 141.7 141.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#00983A;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st2{display:inline;fill:#E30613;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st3{display:inline;fill:#EA5B0C;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st4{display:inline;fill:#FFDE00;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st5{display:inline;fill:#27348B;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st6{display:inline;fill:#82368C;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st7{display:inline;}\r\n\t.st8{fill:#1D1D1B;}\r\n\t.st9{fill:none;stroke:#1D1D1B;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st10{display:inline;fill:#1D1D1B;}\r\n\t.st11{display:inline;fill:none;stroke:#1D1D1B;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st12{display:inline;fill:#3AAA35;}\r\n\t.st13{display:inline;fill:#FFFFFF;}\r\n\t.st14{fill:#FFFFFF;}\r\n\t.st15{display:inline;fill:#FFFFFF;stroke:#1D1D1B;stroke-linecap:square;stroke-miterlimit:10;}\r\n\t.st16{display:inline;fill:none;stroke:#1D1D1B;stroke-linecap:square;stroke-miterlimit:10;}\r\n\t.st17{fill:none;stroke:#1D1D1B;stroke-miterlimit:10;}\r\n\t.st18{fill:url(#SVGID_1_);}\r\n\t.st19{fill:url(#SVGID_2_);}\r\n\t.st20{fill:url(#SVGID_3_);}\r\n\t.st21{fill:url(#SVGID_4_);}\r\n\t.st22{fill:#1C8A90;}\r\n\t.st23{fill:#09B4BD;}\r\n\t.st24{font-family:'Montserrat-Black';}\r\n\t.st25{font-size:29.393px;}\r\n\t.st26{fill:#82368C;}\r\n\t.st27{display:inline;fill:url(#SVGID_5_);}\r\n\t.st28{display:inline;fill:url(#SVGID_6_);stroke:#8C8C8C;}\r\n\t.st29{display:inline;fill:url(#SVGID_7_);stroke:#8C8C8C;}\r\n\t.st30{display:inline;fill:url(#SVGID_8_);stroke:#8C8C8C;}\r\n\t.st31{display:inline;fill:url(#SVGID_9_);stroke:#8C8C8C;}\r\n\t.st32{display:inline;fill:url(#SVGID_10_);stroke:#8C8C8C;}\r\n\t.st33{display:inline;fill:url(#SVGID_11_);stroke:#8C8C8C;}\r\n\t.st34{fill:url(#SVGID_12_);stroke:#8C8C8C;}\r\n\t.st35{fill:url(#SVGID_13_);}\r\n\t.st36{fill:url(#SVGID_14_);}\r\n\t.st37{fill:url(#SVGID_15_);}\r\n\t.st38{fill:url(#SVGID_16_);}\r\n\t.st39{fill:url(#SVGID_17_);}\r\n\t.st40{fill:url(#SVGID_18_);}\r\n\t.st41{fill:url(#SVGID_19_);}\r\n\t.st42{fill:url(#SVGID_20_);}\r\n\t.st43{fill:url(#SVGID_21_);}\r\n\t.st44{fill:url(#SVGID_22_);}\r\n\t.st45{fill:url(#SVGID_23_);}\r\n\t.st46{fill:url(#SVGID_24_);}\r\n\t.st47{fill:url(#SVGID_25_);}\r\n\t.st48{fill:url(#SVGID_26_);}\r\n\t.st49{fill:url(#SVGID_27_);}\r\n\t.st50{fill:url(#SVGID_28_);}\r\n\t.st51{fill:url(#SVGID_29_);}\r\n\t.st52{fill:none;stroke:#D60B52;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st53{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st54{opacity:0.8;fill:#09B4BD;}\r\n\t.st55{fill:url(#SVGID_30_);}\r\n\t.st56{fill:url(#SVGID_31_);}\r\n\t.st57{fill:url(#SVGID_32_);}\r\n\t.st58{fill:url(#SVGID_33_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 31.2,
    className: "st8",
    width: 5.7,
    height: 22.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.2,
    y: 31.2,
    className: "st8",
    width: 5.7,
    height: 22.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.9,
    y: 42.5,
    className: "st8",
    width: 11.3,
    height: 5.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 59.5,
    className: "st8",
    width: 5.7,
    height: 22.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.9,
    y: 76.5,
    className: "st8",
    width: 17,
    height: 5.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.4,
    y: 59.5,
    className: "st8",
    width: 5.7,
    height: 22.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.9,
    y: 59.5,
    className: "st8",
    width: 22.7,
    height: 5.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.5,
    y: 42.5,
    className: "st8",
    width: 5.7,
    height: 11.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.5,
    y: 42.5,
    className: "st8",
    width: 5.7,
    height: 11.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.2,
    y: 42.5,
    className: "st8",
    width: 11.3,
    height: 5.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 59.5,
    className: "st8",
    width: 14.2,
    height: 5.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 76.5,
    className: "st8",
    width: 14.2,
    height: 5.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M82.2,42.5c0-6.3-5.1-11.3-11.3-11.3c-6.3,0-11.3,5.1-11.3,11.3h5.7c0-3.1,2.5-5.7,5.7-5.7 c3.1,0,5.7,2.5,5.7,5.7H82.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M68,70.9c-1.6,0-2.8-1.3-2.8-2.8s1.3-2.8,2.8-2.8v-5.7c-4.7,0-8.5,3.8-8.5,8.5c0,1,0.2,1.9,0.5,2.8H68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M68,70.9h-8c-0.3,0.9-0.5,1.8-0.5,2.8c0,4.7,3.8,8.5,8.5,8.5v-5.7c-1.6,0-2.8-1.3-2.8-2.8 C65.2,72.1,66.5,70.9,68,70.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.6,
    y: 43.9,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 154.4882 -60.9449)",
    className: "st8",
    width: 14.2,
    height: 5.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.6,
    y: 43.9,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 137.4803 -43.937)",
    className: "st8",
    width: 14.2,
    height: 5.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M99.2,39.7c0-1.6,1.3-2.8,2.8-2.8s2.8,1.3,2.8,2.8h5.7c0-4.7-3.8-8.5-8.5-8.5c-1,0-1.9,0.2-2.8,0.5V39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M99.2,39.7v-8c-0.9-0.3-1.8-0.5-2.8-0.5c-4.7,0-8.5,3.8-8.5,8.5h5.7c0-1.6,1.3-2.8,2.8-2.8 C97.9,36.9,99.2,38.1,99.2,39.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.3,
    y: 28.3,
    className: "st9",
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.7,
    y: 28.3,
    className: "st9",
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 28.3,
    className: "st9",
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.3,
    y: 56.7,
    className: "st9",
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.7,
    y: 56.7,
    className: "st9",
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 56.7,
    className: "st9",
    width: 28.3,
    height: 28.3
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M34,138.9L34,138.9c-1.6,0-2.8-1.3-2.8-2.8v-17c0-1.6,1.3-2.8,2.8-2.8h0c1.6,0,2.8,1.3,2.8,2.8v17 C36.9,137.6,35.6,138.9,34,138.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M51,138.9L51,138.9c1.6,0,2.8-1.3,2.8-2.8v-17c0-1.6-1.3-2.8-2.8-2.8h0c-1.6,0-2.8,1.3-2.8,2.8v17 C48.2,137.6,49.5,138.9,51,138.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.9,
    y: 127.6,
    className: "st10",
    width: 11.3,
    height: 5.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M65.2,127.6h-5.7v8.5c0,1.6,1.3,2.8,2.8,2.8h0c1.6,0,2.8-1.3,2.8-2.8V127.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M79.4,138.9L79.4,138.9c-1.6,0-2.8-1.3-2.8-2.8v-8.5h5.7v8.5C82.2,137.6,80.9,138.9,79.4,138.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M90.7,138.9L90.7,138.9c-1.6,0-2.8-1.3-2.8-2.8v-12.8h5.7v12.8C93.5,137.6,92.3,138.9,90.7,138.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M99.2,127.6L99.2,127.6c-1.6,0-2.8-1.3-2.8-2.8v-1.4h5.7v1.4C102,126.3,100.8,127.6,99.2,127.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M107.7,138.9L107.7,138.9c-1.6,0-2.8-1.3-2.8-2.8v-12.8h5.7v12.8C110.6,137.6,109.3,138.9,107.7,138.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.2,
    y: 127.6,
    className: "st10",
    width: 11.3,
    height: 5.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M82.2,127.6c0-6.3-5.1-11.3-11.3-11.3c-6.3,0-11.3,5.1-11.3,11.3h5.7c0-3.1,2.5-5.7,5.7-5.7 c3.1,0,5.7,2.5,5.7,5.7H82.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.3,
    y: 113.4,
    className: "st11",
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.7,
    y: 113.4,
    className: "st11",
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 113.4,
    className: "st11",
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.3,
    y: 141.7,
    className: "st11",
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.7,
    y: 141.7,
    className: "st11",
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 141.7,
    className: "st11",
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.7,
    y: 28.3,
    className: "st9",
    width: 28.3,
    height: 28.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.7,
    y: 56.7,
    className: "st9",
    width: 28.3,
    height: 28.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.7,
    y: 85,
    className: "st9",
    width: 28.3,
    height: 28.3
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 66.6,
    cy: 66.6,
    r: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M103.5,121.9c0.8,0,1.4,0.6,1.4,1.4v0l0,0h5.7c0-3.9-3.2-7.1-7.1-7.1c-1.6,0-3.1,0.5-4.3,1.4 c-1.2-0.9-2.7-1.4-4.3-1.4c-3.9,0-7.1,3.2-7.1,7.1h5.7l0,0v0c0-0.8,0.6-1.4,1.4-1.4s1.4,0.6,1.4,1.4h5.7 C102,122.5,102.7,121.9,103.5,121.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M82.2,59.5h-51l-2.8-2.8v56.7l2.8-2.8h51l2.8,2.8V56.7L82.2,59.5z M68,96.4v-5.7h-5.7H51h-5.7v5.7l-5.7,5.7 V68l5.7,5.7V85h11.3H68V73.7l5.7-5.7v34L68,96.4z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 8.5038 25.5118)",
    className: "st7 st24 st25"
  }, "HAMLET"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "73.7,90.7 62.4,90.7 62.4,62.4 51,62.4 51,119.1 62.4,119.1 62.4,102 73.7,102 73.7,119.1 85,119.1  85,62.4 73.7,62.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M99.2,62.4L87.9,85v34h11.3v-17h11.3v17h11.3V85l-11.3-22.7H99.2z M110.6,90.7H99.2V85l5.7-11.3l5.7,11.3 V90.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "158.7,62.4 153.1,62.4 147.4,82.2 141.7,62.4 136.1,62.4 130.4,62.4 124.7,62.4 124.7,119.1  136.1,119.1 136.1,82.2 141.7,102 153.1,102 158.7,82.2 158.7,119.1 170.1,119.1 170.1,62.4 164.4,62.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 121.9,
    className: "st10",
    width: 119.1,
    height: 11.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 294.8435,
    y1: 300.4321,
    x2: 46.5513,
    y2: 52.1398
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.007772021,
    style: {
      stopColor: "#EA5B0C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1921,
    style: {
      stopColor: "#E9550D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4454,
    style: {
      stopColor: "#E8430E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7372,
    style: {
      stopColor: "#E62610"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E30613"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_1_)"
    },
    d: "M209.5,45.4v70.9v14.2v0.4h-84.4v-8.9h-0.2V45.4H73.7c0,0-23,1.1-28.2,8 c-5.2,6.8-5.6,35-5.6,35v42.1h0v85v8.5v76.5h85.3v-76.5v-8.1h84.4v13.8v70.9h85.3v-70.9v-14.2v-85v-14.2V45.4H209.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.8467,
    y1: 172.9144,
    x2: 125.1222,
    y2: 172.9144,
    gradientTransform: "matrix(1 0 0 1 -2.000000e-04 -1.000000e-03)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ADADAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 39.8,
    y: 130.4,
    style: {
      display: "inline",
      fill: "url(#SVGID_2_)",
      stroke: "#8C8C8C"
    },
    width: 85.3,
    height: 85
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.4884,
    y1: 173.312,
    x2: 209.764,
    y2: 173.312,
    gradientTransform: "matrix(1 0 0 1 -2.000000e-04 -1.000000e-03)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ADADAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 124.5,
    y: 130.8,
    style: {
      display: "inline",
      fill: "url(#SVGID_3_)",
      stroke: "#8C8C8C"
    },
    width: 85.3,
    height: 85
  }), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.5918,
    y1: 52.1005,
    x2: 124.886,
    y2: 130.3947,
    gradientTransform: "matrix(1 0 0 1 -2.000000e-04 -1.000000e-03)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ADADAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)",
      stroke: "#8C8C8C"
    },
    d: "M124.9,130.4h-85V88.3c0,0,0.4-28.2,5.6-35c5.2-6.8,28.2-8,28.2-8h51.2 V130.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.3554,
    y1: 71.1158,
    x2: 45.3259,
    y2: 53.2044,
    gradientTransform: "matrix(1 0 0 1 -2.000000e-04 -1.000000e-03)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2692,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    style: {
      stopColor: "#F9F9F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7173,
    style: {
      stopColor: "#E7E7E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M39.8,88.3c0,0,0.4-28.2,5.6-35c5.2-6.8,28.2-8,28.2-8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.094947e-13,
    y1: 106.2992,
    x2: 141.7323,
    y2: 106.2992
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    points: "141.7,141.7 70.9,70.9 0,141.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.260149e-7,
    y1: 35.4331,
    x2: 141.7323,
    y2: 35.4331
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_7_)"
    },
    points: "0,0 70.9,70.9 141.7,0  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.8662,
    y1: 70.8661,
    x2: 141.7323,
    y2: 70.8661
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_8_)"
    },
    points: "141.7,0 70.9,70.9 141.7,141.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.260149e-7,
    y1: 70.8661,
    x2: 70.8661,
    y2: 70.8661
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_9_)"
    },
    points: "0,141.7 70.9,70.9 0,0  "
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "56.7,85 99.2,85 99.2,99.2 127.6,127.6 127.6,14.2 99.2,42.5 99.2,56.7 85,56.7  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "85,56.7 42.5,56.7 42.5,42.5 14.2,14.2 14.2,127.6 42.5,99.2 42.5,85 56.7,85  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogook01);
export default __webpack_public_path__ + "static/media/logo ok-01.7074cfe503eef1794397b1ee5b14f8b4.svg";
export { ForwardRef as ReactComponent };